export const WhatAreMidRiseApartments = () => {
  const characteristics = [
    {
      icon: 'ri-building-line',
      title: '4-8 Stories',
      description: 'Typically 4 to 8 floors with elevator access and modern amenities'
    },
    {
      icon: 'ri-community-line',
      title: 'Urban Locations',
      description: 'Prime locations in city centers and high-density neighborhoods'
    },
    {
      icon: 'ri-home-smile-line',
      title: '30-100 Units',
      description: 'Medium-scale properties with professional management requirements'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Commercial Features',
      description: 'Structured parking, security systems, and commercial-grade infrastructure'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900">
            What Are Mid-Rise Apartment Buildings?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Mid-rise apartments represent the sweet spot in multifamily real estate—large enough for institutional-quality returns, yet manageable enough for individual investors. These properties combine urban density with accessible scale.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {characteristics.map((item, index) => (
            <div key={index} className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-all duration-300">
              <div className="w-14 h-14 flex items-center justify-center bg-teal-500 text-white rounded-lg mb-4">
                <i className={`${item.icon} text-2xl`}></i>
              </div>
              <h3 className="text-xl font-bold mb-3 text-gray-900">{item.title}</h3>
              <p className="text-gray-600 leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-br from-teal-50 to-cyan-50 rounded-2xl p-8 md:p-12">
          <h3 className="text-2xl font-bold mb-6 text-gray-900">Why Mid-Rise Properties Are Unique</h3>
          <div className="grid md:grid-cols-2 gap-8">
            <div>
              <h4 className="text-lg font-semibold mb-3 text-gray-900">Investment Advantages</h4>
              <ul className="space-y-3 text-gray-700">
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-500 text-xl mr-3 mt-1"></i>
                  <span>Higher income potential than low-rise properties</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-500 text-xl mr-3 mt-1"></i>
                  <span>Economies of scale in management and maintenance</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-500 text-xl mr-3 mt-1"></i>
                  <span>Attractive to institutional buyers and investors</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-500 text-xl mr-3 mt-1"></i>
                  <span>Strong appreciation in urban markets</span>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="text-lg font-semibold mb-3 text-gray-900">Management Considerations</h4>
              <ul className="space-y-3 text-gray-700">
                <li className="flex items-start">
                  <i className="ri-arrow-right-line text-teal-500 text-xl mr-3 mt-1"></i>
                  <span>Professional property management typically required</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-arrow-right-line text-teal-500 text-xl mr-3 mt-1"></i>
                  <span>Higher operating expenses and capital requirements</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-arrow-right-line text-teal-500 text-xl mr-3 mt-1"></i>
                  <span>Complex building systems and infrastructure</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-arrow-right-line text-teal-500 text-xl mr-3 mt-1"></i>
                  <span>Regulatory compliance and safety requirements</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};